// tslint:disable: naming-convention
import { Action } from '@ngrx/store';
import { SpezifikationsArtEntity } from '../../../entities/mdqx/spezifikations-art.entity';

export enum SpezifikationsArtActionTypes {
    GetSpezifikationsArtenRequest = '[SpezifikationsArten] Get Request',
    GetSpezifikationsArtenResponse = '[SpezifikationsArten] Get Response',
}

export class GetSpezifikationsArtenRequest implements Action {
    readonly type = SpezifikationsArtActionTypes.GetSpezifikationsArtenRequest;
}

export class GetSpezifikationsArtenResponse implements Action {
    readonly type = SpezifikationsArtActionTypes.GetSpezifikationsArtenResponse;
    constructor(public Payload: SpezifikationsArtEntity[]) {}
}


export type SpezifikationsArtActions =
    | GetSpezifikationsArtenRequest
    | GetSpezifikationsArtenResponse;
